import { MultiSelect } from '@mantine/core'
import { useTranslation } from 'react-i18next'

interface StudentMultiSelectProps {
  options: Array<{ value: string; label: string }>
  value: string[]
  onChange: (next: string[]) => void
  disabled?: boolean
}

export function StudentMultiSelect({ options, value, onChange, disabled }: StudentMultiSelectProps) {
  const { t } = useTranslation()
  return (
    <MultiSelect
      label={t('arc_teacher_assessment_drawer.student_label')}
      data={options}
      value={value}
      onChange={onChange}
      searchable
      clearable
      disabled={disabled}
      nothingFound={t('arc_teacher_assessment_drawer.no_student_match')}
    />
  )
}
